/**
 * Query keys for public holiday queries
 */

const scopes = {
  publicHolidays: "publicHolidays",
} as const;

export const publicHolidayKeys = {
  publicHolidays: {
    scope: scopes.publicHolidays,
    all: () => [scopes.publicHolidays] as const,
    byYear: (year: number) => [scopes.publicHolidays, { year }] as const,
    byYearAndBundesland: (year: number, bundesland: string) =>
      [scopes.publicHolidays, { year, bundesland }] as const,
    detail: (id: number) => [scopes.publicHolidays, "detail", id] as const,
  },
};